/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
export const EXTERIOR_CONDITION_PARAM_DEFINITION = 'paramDefinition1243e';
export const INTERIOR_CONDITION_PARAM_DEFINITION = 'paramDefinitione4769';
export const MECHANICAL_CONDITION_PARAM_DEFINITION = 'paramDefinitionb0dff';
